import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { GetDepartmentsList } from "../Responses/GetDepartmentsList";

export async function getDepartmentsList(data) {
	let response = await getAPIResponse("/v1/department-list", data);
	if (response === null) {
		return null;
	}
	let getDepartmentsList = GetDepartmentsList.createFromResponseData(response);
	return getDepartmentsList;
}